import { Box, Button, Modal } from 'tombac';
import { useUserDetails } from "../../users/UserDetailsProvider";
import { useRemoveAccessMutation } from "../../users/api/userManagementApiHooks";
import { ProductModalHeader } from "./ProductModalHeader";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RemoveAccessModal = _ref => {
  let {
    isOpen,
    onRequestClose,
    onSuccess,
    productId
  } = _ref;
  const user = useUserDetails();
  const {
    isLoading,
    mutate: removeAccess
  } = useRemoveAccessMutation();
  const handleRemoveClick = () => {
    removeAccess({
      productId,
      username: user.email
    }, {
      onSuccess
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    isOpen: isOpen,
    onRequestClose: onRequestClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "RemoveAccessModal",
    "data-sentry-source-file": "RemoveAccessModal.tsx",
    children: [/*#__PURE__*/_jsx(ProductModalHeader, {
      onRequestClose: onRequestClose,
      productId: productId,
      subtitle: "Are you sure you want to remove access to this product?",
      title: "Remove access",
      "data-sentry-element": "ProductModalHeader",
      "data-sentry-source-file": "RemoveAccessModal.tsx",
      "data-sentry-element": "ProductModalHeader"
    }), /*#__PURE__*/_jsxs(Box, {
      $display: "flex",
      $pb: "3sp",
      $pr: "4sp",
      $pt: "2sp",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "RemoveAccessModal.tsx",
      "data-sentry-element": "Box",
      children: [/*#__PURE__*/_jsx(Button, {
        $ml: "auto",
        onClick: onRequestClose,
        type: "button",
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "RemoveAccessModal.tsx",
        "data-sentry-element": "Button",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        busy: isLoading,
        disabled: !isOpen,
        onClick: handleRemoveClick,
        $ml: "1sp",
        type: "submit",
        variant: "danger",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "RemoveAccessModal.tsx",
        "data-sentry-element": "Button",
        children: "Yes, remove access"
      })]
    })]
  });
};